import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import { Link, Route, withRouter, Switch, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import CaseInformation from './CaseInformation';
import EnquirySubmission from './EnquirySubmission';
import ArbitratorNotice from './ArbitratorNotice';
import Award from './Award';
import TeleConferencing from './TeleConferencing';
import DocsList from './DocsList';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import PrimaryAppBar from '../../components/PrimaryAppBar';
import Settlement from './Settlement';
import Response from './Response';
import CircularProgress from '@material-ui/core/CircularProgress';
import withSizes from 'react-sizes';

const styles = theme => ({
    isMobileFormControl: {
        marginLeft: 'auto',
        //marginRight: '0px',
        marginRight: 'auto',
        //display: 'flex',
        //alignItems: 'center',
    },
    active_tabStyle:{
        color: 'white',
        backgroundColor: '#B71C1C',
        outline: '0'
    },
    root:{
        width:'100vw'
    },
    /*tabLabel:{
        fontSize: 12,
    },*/
    [theme.breakpoints.down('xs')]: {
        tabLabel:{
            fontSize: 12,
        },
    },
    [theme.breakpoints.up('sm')]: {
        tabLabel:{
            fontSize: 12,
        },
    },
    [theme.breakpoints.up('md')]: {
        tabLabel:{
            fontSize: 12,
        },
    },
});

function TabContainer(props) {
    return (
      <Typography component="div" 
    //   style={{ padding: 8 * 3 }}
      >
        {props.children}
      </Typography>
    );
}
  
TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

function LinkTab(props) {
    return <Tab component={Link} {...props} />;
}

class NavTabs extends Component {

    state={
        tab: '',
        value: 0,
        typeOfAccount: localStorage.getItem('typeOfAccount')
    }

    componentDidUpdate(){

    }

    checkLanguage = function() {
        try{
          if (this.props.isLoading){
            setTimeout(()=>{this.checkLanguage()},100)
          }
          else{
            console.log('this caseData: '+JSON.stringify(this.props.caseData))
            var lang = localStorage.getItem('language');
            if (this.props !== undefined){
              if (this.props.caseData !== undefined){
                if (this.props.caseData.language !== undefined){
                  if (this.props.caseData.language == 'Chi'){
                    if (lang == 'en' || lang == undefined){
                      localStorage.setItem('language', 'cn');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                  else if (this.props.caseData.language == 'Eng'){
                    if (lang == 'cn' || lang == undefined){
                      localStorage.setItem('language', 'en');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                }
              }
            }
          }
        }catch(err){
          setTimeout(()=>{this.checkLanguage()},100)
        }
      }

    componentDidMount(){
        console.log('localStorage.getItem(caseId): '+localStorage.getItem('caseId'))
        console.log('localStorage.getItem(token): '+localStorage.getItem('token'))
        this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'));
        this.props.getUserInformation(localStorage.getItem('token'));
        this.checkLanguage();

      }

    componentWillMount(){
        console.log('localStorage.getItem(caseId): '+localStorage.getItem('caseId'))
        console.log('localStorage.getItem(token): '+localStorage.getItem('token'))
        // window.testOff();
        this.props.getCaseInfo(localStorage.getItem('caseId'), localStorage.getItem('token'));
        this.props.getUserInformation(localStorage.getItem('token'));

        // var currentTabPos = localStorage.getItem('currentTabPos')
        // console.log('currentTabPos: '+currentTabPos)
        // if (currentTabPos !== null){
        //     this.setState({
        //         value: parseInt(currentTabPos)
        //     })
        // }
       
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleChangeSelect = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render(){
        const { classes } = this.props;
        const { value } = this.state;
        // console.log('NavTabs : this.props.isAuthenticated: '+this.props.isAuthenticated)
        if(!this.props.isAuthenticated){
            return(<Redirect to='/' />)
        }

        if(this.props.isLoading){
            // return(<Redirect to='/' />)
            return(<CircularProgress size={50} thickness={3} className={classes.progress}/>)
        }
        else{
        
        
        //if(this.props.newAccount === null || this.props.newAccount === undefined){
         //   return(<CircularProgress size={50} thickness={3} className={classes.progress}/>)
        //}
        if(this.props.newAccount !== null && this.props.newAccount !== undefined && this.props.newAccount){
            return(<Redirect to={`/cases/${this.props.match.params.id}/OnBoarding`} />)
        }

            if (this.state.typeOfAccount == 'arbitrator'){
                return(
                    <div className={classes.root}>
                        <PrimaryAppBar />
                        <AppBar position="sticky" color="default">
                            <Tabs 
                                value={value} 
                                onChange={this.handleChange} 
                                indicatorColor="primary" 
                                className={ classes.indicator }
                                scrollable
                                // tabItemContainerStyle={{width: '400px'}}
                                variant="scrollable"
                                scrollButtons="off"
                            >
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Case Information')}</span> } to={`${this.props.match.url}`} className={this.state.value===0 ? classes.active_tabStyle : null}/>
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Arbitration Notice')}</span> } to={`${this.props.match.url}`} className={this.state.value===1 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab label={<span className={classes.tabLabel}>Claimant's Document</span>} to={`${this.props.match.url}/claimantsDocument`} className={this.state.value===2 ? classes.active_tabStyle : null}/> */}
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Response')}</span>} to={`${this.props.match.url}`} className={this.state.value===2 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab label={<span className={classes.tabLabel}>Documents</span>} to={`${this.props.match.url}/Documents`} className={this.state.value===3 ? classes.active_tabStyle : null}/> */}
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Documents')}</span>} to={`${this.props.match.url}`} className={this.state.value===3 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab label={<span className={classes.tabLabel}>Respondent's Document</span>} to={`${this.props.match.url}/respondentsDocument`} className={this.state.value===4 ? classes.active_tabStyle : null}/> */}
                                {/* <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Settlement')}</span>} to={`${this.props.match.url}`} className={this.state.value===4 ? classes.active_tabStyle : null}/> */}
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Enquiries & Submission')}</span>} to={`${this.props.match.url}`} className={this.state.value===4 ? classes.active_tabStyle : null}/>
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Award')}</span>} to={`${this.props.match.url}`} className={this.state.value===5 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Hearing')}</span>} to={`${this.props.match.url}`} className={this.state.value===6 ? classes.active_tabStyle : null}/> */}
                            </Tabs>
                        </AppBar>
                        
                        {value === 0 && <CaseInformation caseData={this.props.caseData}/>}
                        {value === 1 && <ArbitratorNotice/>}
                        {/*value === 2 && <TabContainer>Claimant's Document</TabContainer>*/}
                        {value === 2 && <Response/>}
                        {value === 3 && <DocsList caseData={this.props.caseData} docs={{claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType ==='All'} />}
                        {/*value === 4 && <TabContainer>Respondent's Document</TabContainer>*/}
                        {/* {value === 4 && <Settlement/>} */}
                        {value === 4 && <EnquirySubmission/>}
                        {value === 5 && <Award/>}
                        {/* {value === 6 && <TeleConferencing/>} */}

                        {/* <Switch> */}
                            {/* <Route path={`${this.props.match.path}/claimantsDocument`} render={ () => <DocsList docs={this.props.claimant_docs} showUploadDocs={this.props.userType =='claimant'}/>} /> */}
                            {/* <Route path={`${this.props.match.path}/respondentsDocument`} render={ () => <DocsList docs={this.props.respondent_docs} showUploadDocs={this.props.userType =='respondent'}/>} /> */}
                            {/* <Route path={`${this.props.match.path}/Documents`} render={ () => <DocsList docs={{claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType =='All'} />} /> */}
                    {/*  </Switch> */}
                
                    </div>
                );
            }
            else if (this.state.typeOfAccount == 'admin'){
                return(
                    <div className={classes.root}>
                        <PrimaryAppBar />
                        <AppBar position="sticky" color="default">
                            <Tabs 
                                value={value} 
                                onChange={this.handleChange} 
                                indicatorColor="primary" 
                                className={ classes.indicator }
                                scrollable
                                // tabItemContainerStyle={{width: '400px'}}
                                variant="scrollable"
                                scrollButtons="off"
                            >
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Case Information')}</span>} to={`${this.props.match.url}`} className={this.state.value===0 ? classes.active_tabStyle : null}/>
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Arbitration Notice')}</span>} to={`${this.props.match.url}`} className={this.state.value===1 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab label={<span className={classes.tabLabel}>Claimant's Document</span>} to={`${this.props.match.url}/claimantsDocument`} className={this.state.value===2 ? classes.active_tabStyle : null}/> */}
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Response')}</span>} to={`${this.props.match.url}`} className={this.state.value===2 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab label={<span className={classes.tabLabel}>Documents</span>} to={`${this.props.match.url}/Documents`} className={this.state.value===3 ? classes.active_tabStyle : null}/> */}
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Documents')}</span>} to={`${this.props.match.url}`} className={this.state.value===3 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab label={<span className={classes.tabLabel}>Respondent's Document</span>} to={`${this.props.match.url}/respondentsDocument`} className={this.state.value===4 ? classes.active_tabStyle : null}/> */}
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Settlement')}</span>} to={`${this.props.match.url}`} className={this.state.value===4 ? classes.active_tabStyle : null}/>
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Enquiries & Submission')}</span>} to={`${this.props.match.url}`} className={this.state.value===5 ? classes.active_tabStyle : null}/>
                                <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Award')}</span>} to={`${this.props.match.url}`} className={this.state.value===6 ? classes.active_tabStyle : null}/>
                                {/* <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Hearing')}</span>} to={`${this.props.match.url}`} className={this.state.value===7 ? classes.active_tabStyle : null}/> */}
                                
                            </Tabs>
                        </AppBar>
                        
                        {value === 0 && <CaseInformation caseData={this.props.caseData}/>}
                        {value === 1 && <ArbitratorNotice/>}
                        {/*value === 2 && <TabContainer>Claimant's Document</TabContainer>*/}
                        {value === 2 && <Response/>}
                        {value === 3 && <DocsList caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType ==='All'} />}
                        {/*value === 4 && <TabContainer>Respondent's Document</TabContainer>*/}
                        {value === 4 && <Settlement/>}
                        {value === 5 && <EnquirySubmission/>}
                        {value === 6 && <Award/>}
                        {/* {value === 7 && <TeleConferencing/>} */}
                        

                        {/* <Switch> */}
                            {/* <Route path={`${this.props.match.path}/claimantsDocument`} render={ () => <DocsList docs={this.props.claimant_docs} showUploadDocs={this.props.userType =='claimant'}/>} /> */}
                            {/* <Route path={`${this.props.match.path}/respondentsDocument`} render={ () => <DocsList docs={this.props.respondent_docs} showUploadDocs={this.props.userType =='respondent'}/>} /> */}
                            {/* <Route path={`${this.props.match.path}/Documents`} render={ () => <DocsList docs={{claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType =='All'} />} /> */}
                    {/*  </Switch> */}
                
                    </div>
                );
            }
            else if (this.state.typeOfAccount == 'user'){
                if (this.props.caseData !== undefined && this.props.caseData !== null){
                    if (this.props.caseData.teleconferencing !== undefined){
                        if (this.props.caseData.teleconferencing == true){
                            return(
                                <div className={classes.root}>
                                    <PrimaryAppBar />
                                    <AppBar position="sticky" color="default">
                                        <Tabs 
                                            value={value} 
                                            onChange={this.handleChange} 
                                            indicatorColor="primary" 
                                            className={ classes.indicator }
                                            scrollable
                                            // tabItemContainerStyle={{width: '400px'}}
                                            variant="scrollable"
                                            scrollButtons="off"
                                        >
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Case Information')}</span>} to={`${this.props.match.url}`} className={this.state.value===0 ? classes.active_tabStyle : null}/>
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Arbitration Notice')}</span>} to={`${this.props.match.url}`} className={this.state.value===1 ? classes.active_tabStyle : null}/>
                                            {/* <LinkTab label={<span className={classes.tabLabel}>Claimant's Document</span>} to={`${this.props.match.url}/claimantsDocument`} className={this.state.value===2 ? classes.active_tabStyle : null}/> */}
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Response')}</span>} to={`${this.props.match.url}`} className={this.state.value===2 ? classes.active_tabStyle : null}/>
                                            {/* <LinkTab label={<span className={classes.tabLabel}>Documents</span>} to={`${this.props.match.url}/Documents`} className={this.state.value===3 ? classes.active_tabStyle : null}/> */}
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Documents')}</span>} to={`${this.props.match.url}`} className={this.state.value===3 ? classes.active_tabStyle : null}/>
                                            {/* <LinkTab label={<span className={classes.tabLabel}>Respondent's Document</span>} to={`${this.props.match.url}/respondentsDocument`} className={this.state.value===4 ? classes.active_tabStyle : null}/> */}
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Settlement')}</span>} to={`${this.props.match.url}`} className={this.state.value===4 ? classes.active_tabStyle : null}/>
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Enquiries & Submission')}</span>} to={`${this.props.match.url}`} className={this.state.value===5 ? classes.active_tabStyle : null}/>
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Award')}</span>} to={`${this.props.match.url}`} className={this.state.value===6 ? classes.active_tabStyle : null}/>
                                            {/* <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Hearing')}</span>} to={`${this.props.match.url}`} className={this.state.value===7 ? classes.active_tabStyle : null}/> */}
                                        </Tabs>
                                    </AppBar>
                                    
                                    {value === 0 && <CaseInformation caseData={this.props.caseData}/>}
                                    {value === 1 && <ArbitratorNotice/>}
                                    {/*value === 2 && <TabContainer>Claimant's Document</TabContainer>*/}
                                    {value === 2 && <Response/>}
                                    {value === 3 && <DocsList caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType ==='All'} />}
                                    {/*value === 4 && <TabContainer>Respondent's Document</TabContainer>*/}
                                    {value === 4 && <Settlement/>}
                                    {value === 5 && <EnquirySubmission/>}
                                    {value === 6 && <Award/>}
                                    {/* {value === 7 && <TeleConferencing/>} */}

                                    {/* <Switch> */}
                                        {/* <Route path={`${this.props.match.path}/claimantsDocument`} render={ () => <DocsList docs={this.props.claimant_docs} showUploadDocs={this.props.userType =='claimant'}/>} /> */}
                                        {/* <Route path={`${this.props.match.path}/respondentsDocument`} render={ () => <DocsList docs={this.props.respondent_docs} showUploadDocs={this.props.userType =='respondent'}/>} /> */}
                                        {/* <Route path={`${this.props.match.path}/Documents`} render={ () => <DocsList docs={{claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType =='All'} />} /> */}
                                {/*  </Switch> */}
                            
                                </div>
                            );
                        }
                        else{
                            return(
                                <div className={classes.root}>
                                    <PrimaryAppBar />
                                    <AppBar position="sticky" color="default">
                                        <Tabs 
                                            value={value} 
                                            onChange={this.handleChange} 
                                            indicatorColor="primary" 
                                            className={ classes.indicator }
                                            scrollable
                                            // tabItemContainerStyle={{width: '400px'}}
                                            variant="scrollable"
                                            scrollButtons="off"
                                        >
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Case Information')}</span>} to={`${this.props.match.url}`} className={this.state.value===0 ? classes.active_tabStyle : null}/>
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Arbitration Notice')}</span>} to={`${this.props.match.url}`} className={this.state.value===1 ? classes.active_tabStyle : null}/>
                                            {/* <LinkTab label={<span className={classes.tabLabel}>Claimant's Document</span>} to={`${this.props.match.url}/claimantsDocument`} className={this.state.value===2 ? classes.active_tabStyle : null}/> */}
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Response')}</span>} to={`${this.props.match.url}`} className={this.state.value===2 ? classes.active_tabStyle : null}/>
                                            {/* <LinkTab label={<span className={classes.tabLabel}>Documents</span>} to={`${this.props.match.url}/Documents`} className={this.state.value===3 ? classes.active_tabStyle : null}/> */}
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Documents')}</span>} to={`${this.props.match.url}`} className={this.state.value===3 ? classes.active_tabStyle : null}/>
                                            {/* <LinkTab label={<span className={classes.tabLabel}>Respondent's Document</span>} to={`${this.props.match.url}/respondentsDocument`} className={this.state.value===4 ? classes.active_tabStyle : null}/> */}
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Settlement')}</span>} to={`${this.props.match.url}`} className={this.state.value===4 ? classes.active_tabStyle : null}/>
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Enquiries & Submission')}</span>} to={`${this.props.match.url}`} className={this.state.value===5 ? classes.active_tabStyle : null}/>
                                            <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Award')}</span>} to={`${this.props.match.url}`} className={this.state.value===6 ? classes.active_tabStyle : null}/>
                                        </Tabs>
                                    </AppBar>
                                    
                                    {value === 0 && <CaseInformation caseData={this.props.caseData}/>}
                                    {value === 1 && <ArbitratorNotice/>}
                                    {/*value === 2 && <TabContainer>Claimant's Document</TabContainer>*/}
                                    {value === 2 && <Response/>}
                                    {value === 3 && <DocsList caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType ==='All'} />}
                                    {/*value === 4 && <TabContainer>Respondent's Document</TabContainer>*/}
                                    {value === 4 && <Settlement/>}
                                    {value === 5 && <EnquirySubmission/>}
                                    {value === 6 && <Award/>}

                                    {/* <Switch> */}
                                        {/* <Route path={`${this.props.match.path}/claimantsDocument`} render={ () => <DocsList docs={this.props.claimant_docs} showUploadDocs={this.props.userType =='claimant'}/>} /> */}
                                        {/* <Route path={`${this.props.match.path}/respondentsDocument`} render={ () => <DocsList docs={this.props.respondent_docs} showUploadDocs={this.props.userType =='respondent'}/>} /> */}
                                        {/* <Route path={`${this.props.match.path}/Documents`} render={ () => <DocsList docs={{claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType =='All'} />} /> */}
                                {/*  </Switch> */}
                            
                                </div>
                            );
                        }
                    }
                    else{
                        return(
                            <div className={classes.root}>
                                <PrimaryAppBar />
                                <AppBar position="sticky" color="default">
                                    <Tabs 
                                        value={value} 
                                        onChange={this.handleChange} 
                                        indicatorColor="primary" 
                                        className={ classes.indicator }
                                        scrollable
                                        // tabItemContainerStyle={{width: '400px'}}
                                        variant="scrollable"
                                        scrollButtons="off"
                                    >
                                        <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Case Information')}</span>} to={`${this.props.match.url}`} className={this.state.value===0 ? classes.active_tabStyle : null}/>
                                        <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Arbitration Notice')}</span>} to={`${this.props.match.url}`} className={this.state.value===1 ? classes.active_tabStyle : null}/>
                                        {/* <LinkTab label={<span className={classes.tabLabel}>Claimant's Document</span>} to={`${this.props.match.url}/claimantsDocument`} className={this.state.value===2 ? classes.active_tabStyle : null}/> */}
                                        <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Response')}</span>} to={`${this.props.match.url}`} className={this.state.value===2 ? classes.active_tabStyle : null}/>
                                        {/* <LinkTab label={<span className={classes.tabLabel}>Documents</span>} to={`${this.props.match.url}/Documents`} className={this.state.value===3 ? classes.active_tabStyle : null}/> */}
                                        <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Documents')}</span>} to={`${this.props.match.url}`} className={this.state.value===3 ? classes.active_tabStyle : null}/>
                                        {/* <LinkTab label={<span className={classes.tabLabel}>Respondent's Document</span>} to={`${this.props.match.url}/respondentsDocument`} className={this.state.value===4 ? classes.active_tabStyle : null}/> */}
                                        <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Settlement')}</span>} to={`${this.props.match.url}`} className={this.state.value===4 ? classes.active_tabStyle : null}/>
                                        <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Enquiries & Submission')}</span>} to={`${this.props.match.url}`} className={this.state.value===5 ? classes.active_tabStyle : null}/>
                                        <LinkTab  label={<span className={classes.tabLabel}>{this.context.t('Award')}</span>} to={`${this.props.match.url}`} className={this.state.value===6 ? classes.active_tabStyle : null}/>
                                    </Tabs>
                                </AppBar>
                                
                                {value === 0 && <CaseInformation caseData={this.props.caseData}/>}
                                {value === 1 && <ArbitratorNotice/>}
                                {/*value === 2 && <TabContainer>Claimant's Document</TabContainer>*/}
                                {value === 2 && <Response/>}
                                {value === 3 && <DocsList caseData={this.props.caseData} docs={{ claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType ==='All'} />}
                                {/*value === 4 && <TabContainer>Respondent's Document</TabContainer>*/}
                                {value === 4 && <Settlement/>}
                                {value === 5 && <EnquirySubmission/>}
                                {value === 6 && <Award/>}

                                {/* <Switch> */}
                                    {/* <Route path={`${this.props.match.path}/claimantsDocument`} render={ () => <DocsList docs={this.props.claimant_docs} showUploadDocs={this.props.userType =='claimant'}/>} /> */}
                                    {/* <Route path={`${this.props.match.path}/respondentsDocument`} render={ () => <DocsList docs={this.props.respondent_docs} showUploadDocs={this.props.userType =='respondent'}/>} /> */}
                                    {/* <Route path={`${this.props.match.path}/Documents`} render={ () => <DocsList docs={{claimant_docs: this.props.claimant_docs, respondent_docs: this.props.respondent_docs}} showUploadDocs={this.props.userType =='All'} />} /> */}
                            {/*  </Switch> */}
                        
                            </div>
                        );
                    }
                }
                else{
                    return(
                        <div className={classes.button}>
                            <CircularProgress size={25} thickness={2} className={classes.loading}/>
                        </div>
                    )
                    
                }
                
            }
            
        // }
        }
    }
}

const mapStateToProps = (state) => {
    // console.log('#Navtabs state: '+JSON.stringify(state) )
    return {
      isAuthenticated: state.auth.token !== null,
      isLoading: state.userInfo.isLoading,
      userId: state.auth.userId,
      respondent_docs: state.caseInfo.respondent_docs,
      arbitrator_docs: state.caseInfo.arbitrator_docs,
      claimant_docs: state.caseInfo.claimant_docs,
      caseId: state.caseInfo.caseId,
      userType: state.caseInfo.userType,
      caseData: state.caseInfo.caseData,
    //   typeOfAccount: (state.auth.typeOfAccount !== undefined ? state.auth.typeOfAccount : state.userInfo.typeOfAccount),
      //newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`] ? state.caseInfo[`${state.caseInfo.userType}_newAccount`]/*['newAccount']*/ : null,
      newAccount:  state.caseInfo[`${state.caseInfo.userType}_newAccount`],
    }
  }
  
const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId, uniqueId) => dispatch(actions.getCaseInfo(caseId, uniqueId)),
        getUserInformation: (uniqueId) => dispatch(actions.getUserInformation(uniqueId)),
    }
}

const mapSizesToProps = sizes => ({
      isMobile: withSizes.isMobile(sizes),
      isTablet : withSizes.isTablet(sizes),
      isDesktop : withSizes.isDesktop(sizes),
      isGtMobile : withSizes.isGtMobile(sizes),
      isGtTablet : withSizes.isGtTablet(sizes),
      isStTablet : withSizes.isStTablet(sizes),
      isStDesktop : withSizes.isStDesktop(sizes),
      isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
      isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

NavTabs.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(withStyles(styles)(withRouter(NavTabs))));

